import { Component } from "react";
import styles from "./jetpass-slot-list-item.module.less";
import UiBkgImage from "@rnb/ui-bkg-image";
import SiteConfigurationStore from "components/stores/site-configuration-store";
import { extract, DateHelper, isArray, createDate } from "@parksandresorts/core";
import { motion } from "polyfill/motion-polyfill/motion-polyfill";
import TimeSlotItem from "components/block-elements/time-slot-item/time-slot-item";
import dayjs from "dayjs";
import { JETPASS_STEP } from "components/block-elements/jetpass-selection/constants/jetpass-constants";
import { runKeyDownOnEnter } from "components/helpers/interaction-helper";

export default class JetpassSlotListItem extends Component {
  constructor(props) {
    super(props);

    this.imgUrl = extract(props, "image");
    this.attractionName = extract(props, "attractionName");
    this.contentfulName = extract(props, "contentfulAttractionName");
    this.expanded = extract(props, "expanded", false);
    this.attractionName = this.contentfulName ? this.contentfulName : this.attractionName;

    this.availableTimeslotLabel = SiteConfigurationStore.getLabel("JETPASS_AVAILABLE_TIMESLOTS");
    this.headline = SiteConfigurationStore.getLabel("JETPASS_SELECT_PASS_HEADLINE");
    this.paragraph = SiteConfigurationStore.getLabel("JETPASS_SELECT_PASS_PARAGRAPH");
    this.showMoreTimeslotsLabel = SiteConfigurationStore.getLabel("SHOW_MORE_TIMESLOTS");

    this.paragraph = this.props.jetpassSelectSlotText ? this.props.jetpassSelectSlotText : this.paragraph;

    this.selectTimeSlot = this.selectTimeSlot.bind(this);

    this.state = {
      expanded: this.expanded,
    };
  }

  calculateAvailableSlots(timeslots) {
    if (!timeslots) {
      return 0;
    }

    let availSlots = 0;

    if (this.props.multiSelection) {
      for (const timeslot of timeslots) {
        if (timeslot.modifiedQuantity && timeslot.modifiedQuantity > 0) {
          availSlots = availSlots + 1;
        }
      }
    } else {
      for (const timeslot of timeslots) {
        if (timeslot.quantity && timeslot.quantity >= this.props.numberOfGuests) {
          availSlots = availSlots + 1;
        }
      }
    }

    return availSlots;
  }

  divideTimeSlotsByHour(timeSlots) {
    const reducedTimeSlots = timeSlots.reduce((arr, item) => {
      const hoursString = item.timeSlotBegin ? item.timeSlotBegin.substr(11, 2) : "ERROR";
      const objectIndex = arr.findIndex((hourItem) => hourItem.hour === hoursString);

      if (objectIndex === -1) {
        arr.push({ hour: hoursString, items: [item] });
      } else {
        arr[objectIndex].items.push(item);
      }

      return arr;
    }, []);

    return reducedTimeSlots;
  }

  shouldEntryTimeslotBeDisplayed(timeslotBegin) {
    const timeslotBeginDate = dayjs(timeslotBegin);

    const firstEntryTime = extract(this.props, "productTimeLimit.firstEntryTime", null);
    const firstEntryTimeDate = firstEntryTime
      ? dayjs(timeslotBeginDate.format("YYYY-MM-DD") + "T" + firstEntryTime)
      : null;

    const lastEntryTime = extract(this.props, "productTimeLimit.lastEntryTime", null);
    const lastEntryTimeDate = lastEntryTime
      ? dayjs(timeslotBeginDate.format("YYYY-MM-DD") + "T" + lastEntryTime)
      : null;

    if (firstEntryTimeDate) {
      if (firstEntryTimeDate > timeslotBeginDate) {
        return false;
      }
    }

    if (lastEntryTimeDate) {
      if (lastEntryTimeDate < timeslotBeginDate) {
        return false;
      }
    }

    return true;
  }

  shouldJetpassTimeslotBeDisplayed(timeslotBegin) {
    const timeslotBeginDate = dayjs(timeslotBegin);

    const entryTime = extract(this.props.selectedEntryTime, "startDateTime", null);

    const firstFirstTime = extract(this.props, "productTimeLimit.firstRideTime", null);
    const firstRideTimeDate = firstFirstTime
      ? dayjs(timeslotBeginDate.format("YYYY-MM-DD") + "T" + firstFirstTime)
      : null;

    const lastRideTime = extract(this.props, "productTimeLimit.lastRideTime", null);
    const lastRideTimeDate = lastRideTime ? dayjs(timeslotBeginDate.format("YYYY-MM-DD") + "T" + lastRideTime) : null;

    if (!entryTime) {
      //if no entry time check before and after conditions if present
      if (firstRideTimeDate) {
        if (firstRideTimeDate > timeslotBeginDate) {
          return false;
        }
      }

      if (lastRideTimeDate) {
        if (lastRideTimeDate < timeslotBeginDate) {
          return false;
        }
      }

      return true;
    }

    const rideMinutesFromEntry = extract(this.props, "productTimeLimit.rideMinutesFromEntry", null);
    const addedTimeInterval = rideMinutesFromEntry && rideMinutesFromEntry > 0 ? rideMinutesFromEntry : 240;

    const entryTimePlusInterval = dayjs(entryTime).add(addedTimeInterval, "minute");

    if (entryTimePlusInterval >= timeslotBeginDate) {
      if (firstRideTimeDate) {
        if (firstRideTimeDate > timeslotBeginDate) {
          return false;
        }
      }

      if (lastRideTimeDate) {
        if (lastRideTimeDate < timeslotBeginDate) {
          return false;
        }
      }

      return true;
    }

    return false;
  }

  shouldTimeslotBeDisplayed(timeslot) {
    const timeslotBegin = createDate(timeslot.timeSlotBegin);

    return this.props.stepType === JETPASS_STEP
      ? this.shouldJetpassTimeslotBeDisplayed(timeslotBegin)
      : this.shouldEntryTimeslotBeDisplayed(timeslotBegin);
  }

  selectTimeSlot(timeSlot, attractionId) {
    this.props.selectTimeSlot(timeSlot, attractionId);
    setTimeout(() => this.setState({ expanded: false }), 450);
  }

  renderTimeSlotItem(timeSlot) {
    const selected = timeSlot.timeSlotBegin === this.props.selectedTimeSlot;
    const timeslotIdentifier = timeSlot.timeSlotBegin + "-" + timeSlot.timeSlotEnd;
    const otherGuestBookings = this.props.multiSelection
      ? this.props.guestBookingsForAttraction.get(timeslotIdentifier)
      : [];
    const timeSlotDate = createDate(timeSlot.timeSlotBegin);
    const outOfStock = this.props.multiSelection ? timeSlot.modifiedQuantity === 0 : timeSlot.quantity === 0;
    const showQuantity = timeSlot.quantity < this.props.numberOfGuests;
    const disabledSlot =
      outOfStock ||
      (this.props.selectionComplete && !this.props.selectedTimeSlot) ||
      (!this.props.multiSelection && timeSlot.quantity < this.props.numberOfGuests);
    const slotBookedForOtherAttraction = this.props.disabledTimeSlots.find(
      (slot) => slot.timeSlotBegin === timeSlot.timeSlotBegin,
    );

    const timeSlotWithName = {
      ...timeSlot,
      attractionName: this.attractionName,
    };

    return (
      <TimeSlotItem
        key={timeSlot.timeSlotBegin}
        disabled={disabledSlot || (slotBookedForOtherAttraction ? true : false)}
        otherBookedAttractionName={slotBookedForOtherAttraction ? slotBookedForOtherAttraction.attractionName : null}
        selected={selected}
        outOfStock={outOfStock}
        timeSlotDate={timeSlotDate}
        showQuantity={showQuantity}
        quantity={this.props.multiSelection ? timeSlot.modifiedQuantity : timeSlot.quantity}
        otherGuestBookings={otherGuestBookings}
        onClick={
          selected
            ? () => this.props.removeTimeSlot(this.props.attractionId)
            : () => this.selectTimeSlot(timeSlotWithName, this.props.attractionId)
        }
      />
    );
  }

  render() {
    const timeSlotsWithInInterval = this.props.timeSlots.filter((timeslot) => this.shouldTimeslotBeDisplayed(timeslot));
    const availableTimeslots = this.calculateAvailableSlots(timeSlotsWithInInterval);
    const dividedTimeSlotsByHour = this.divideTimeSlotsByHour(timeSlotsWithInInterval);
    const guestBookingsForAttraction = [...this.props.guestBookingsForAttraction.values()].flat();

    const toggleExpand = () => {
      this.setState({ expanded: !this.state.expanded });
    };

    return (
      <div className={styles.outerWrapper}>
        <div className={`${styles.wrapper} ${this.state.expanded ? styles.expanded : ""}`}>
          <div
            className={`${styles.cardWrapper} ${
              isArray(guestBookingsForAttraction) && this.props.multiSelection ? styles.showingGuestDots : ""
            }`}
          >
            <div
              onClick={toggleExpand}
              onKeyDown={(e) => runKeyDownOnEnter(e, toggleExpand)}
              role="button"
              tabIndex={0}
              className={styles.imageWrapper}
            >
              <div className={`${styles.selectedOverlay} ${this.props.selectedTimeSlot ? styles.selected : ""}`}>
                <div
                  className={`${styles.selectedTimeslot} ${
                    this.props.selectedTimeSlot ? styles.visible : styles.hidden
                  }`}
                >
                  {DateHelper.toStringTimeHHMM(createDate(this.props.selectedTimeSlot))}
                </div>
              </div>
              <UiBkgImage
                enableFadeIn={true}
                className={styles.image}
                smallDeviceImageMaxWidth={600}
                largeDeviceImageMaxWidth={450}
                breakPointSmallDevice={9999}
                backgroundSizing="cover"
                imageUrlForSmallDevice={this.imgUrl}
                imageUrlForLargeDevice={this.imgUrl}
              />
            </div>
            <div
              onClick={toggleExpand}
              onKeyDown={(e) => runKeyDownOnEnter(e, toggleExpand)}
              role="button"
              tabIndex={0}
              className={styles.textWrapper}
            >
              <h5 className={styles.headline}>{this.attractionName}</h5>
              {typeof availableTimeslots === "number" && (
                <p className={[styles.availableTimeslotsText, "body-s"].join(" ")}>
                  {" "}
                  {availableTimeslots + " " + this.availableTimeslotLabel}
                </p>
              )}
            </div>
            <div className={styles.removeButtonWrapper}>
              <button
                onClick={
                  this.props.selectedTimeSlot
                    ? () => this.props.removeTimeSlot(this.props.attractionId)
                    : () => this.setState({ expanded: !this.state.expanded })
                }
                className={styles.removeButton}
              >
                {this.props.selectedTimeSlot && <span className={`${styles.icon} icon-close`} />}
              </button>
            </div>
          </div>
          <motion.div
            initial={{ height: this.state.expanded ? "auto" : 0 }}
            animate={{ height: this.state.expanded ? "auto" : 0 }}
            transition={{ type: "tween" }}
            className={styles.slotsWrapper}
          >
            <div className={styles.innerWrapper}>
              {!this.props.selectedTimeSlot && this.props.selectionComplete && (
                <div className={styles.allBookedOverlay}>
                  <h4>Du har valt maximalt antal tider, ta bort en tidsbokning för att kunna välja en ny.</h4>
                </div>
              )}
              <h3 className={`${styles.headline} h6`}>{this.headline}</h3>
              <p className={`${styles.paragraph} body-s`}>{this.paragraph}</p>
              <ul className={styles.timeslots}>
                {dividedTimeSlotsByHour.map((hourObject) => {
                  return (
                    <li key={hourObject.hour} className={styles.row}>
                      {hourObject.items.map((item, index) => this.renderTimeSlotItem(item, index))}
                    </li>
                  );
                })}
              </ul>
            </div>
          </motion.div>
        </div>
        {!this.state.expanded && isArray(guestBookingsForAttraction) && this.props.multiSelection && (
          <div className={[styles.attractionLevelDotWrapper].join(" ")}>
            <p className={[styles.selectedByText, "p_tiny"].join(" ")}>Vald av:</p>
            {guestBookingsForAttraction.map((booking, index) => (
              <div
                key={index}
                style={{ zIndex: index + 1, background: booking.color }}
                className={styles.attractionLevelGuestDot}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}
